import React from 'react';
import * as Urls from 'src/constants/EndpointUrls';
// CSS
import styles from './DownloadColumnDetail.scss';
import { useTranslation } from 'react-i18next';
// CSV ダウンロードカラム説明
const DownloadColumnDetail = () => {
  const { t } = useTranslation();
  return (
    <div className="l-wrap-l">
      <div className="l-overflow-scroll">
        <table className="m-table-description">
          <thead>
            <tr>
              <th className="m-table-description-item-name">{t('features.EmployeePays.components.DownloadColumnDetail.data_item_name')}</th>
              <th>{t('features.EmployeePays.components.DownloadColumnDetail.description')}</th>
              <th className="m-table-description-example">{t('features.EmployeePays.components.DownloadColumnDetail.example')}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th className={styles.detail_item_column}>
                {t('features.EmployeePays.components.DownloadColumnDetail.staff_code')}<span className={styles.required}>{t('features.EmployeePays.components.DownloadColumnDetail.required')}</span>
              </th>
              <td>
                {t('features.EmployeePays.components.DownloadColumnDetail.format')}：{t('features.EmployeePays.components.DownloadColumnDetail.alphanumeric')}<br />
                {t('features.EmployeePays.components.DownloadColumnDetail.data_imported_based_on_staff_code_so_be_sure_to_enter_it_correctly')}
              </td>
              <td>111</td>
            </tr>
            <tr>
              <th>{t('features.EmployeePays.components.DownloadColumnDetail.last_name')}</th>
              <td>{t('features.EmployeePays.components.DownloadColumnDetail.can_leave_this_blank_because_data_is_based_on_staff_code')}</td>
              <td>{t('features.EmployeePays.components.DownloadColumnDetail.Yamada')}</td>
            </tr>
            <tr>
              <th>{t('features.EmployeePays.components.DownloadColumnDetail.first_name')}</th>
              <td>{t('features.EmployeePays.components.DownloadColumnDetail.can_leave_this_blank_because_data_is_based_on_staff_code')}</td>
              <td>{t('features.EmployeePays.components.DownloadColumnDetail.Taro')}</td>
            </tr>
            <tr>
              <th>
                {t('features.EmployeePays.components.DownloadColumnDetail.payment_date')}<span className={styles.required}>{t('features.EmployeePays.components.DownloadColumnDetail.required')}</span>
              </th>
              <td>
                dd/mm/yyyy<br />
                {t('features.EmployeePays.components.DownloadColumnDetail.error_will_occure_if_payment_date_and_input_payment_date_does_not_match')}<br />
                {t('features.EmployeeBonus.components.DownloadColumnDetail.After_switching_the_page_to_the_month_you_want_to_upload_from_the_bonus_list_please_click_Provision_deduction_items_CSV_import_again')}
              </td>
              <td>25/01/2025</td>
            </tr>
            <tr>
              <th>
                {t('features.EmployeeBonus.DownloadCsvPage.bonus_name')}<span className={styles.required}>{t('features.EmployeePays.components.DownloadColumnDetail.required')}</span>
              </th>
              <td>
                {t('features.EmployeeBonus.components.DownloadColumnDetail.If_the_displayed_bonus_name_and_the_input_bonus_name_do_not_match_an_error_will_occur')}<br />
                {t('features.EmployeeBonus.components.DownloadColumnDetail.After_switching_the_page_to_the_month_you_want_to_upload_from_the_bonus_list_please_click_Provision_deduction_items_CSV_import_again')}
              </td>
              <td>{t('features.EmployeeBonus.components.DownloadColumnDetail.performance_bonus')}</td>
            </tr>
            <tr>
              <th>
                {t('features.EmployeePays.components.DownloadColumnDetail.provision_item_name')}<br />{t('features.EmployeePays.components.DownloadColumnDetail.deduction_item_name')}
              </th>
              <td>
                <a href={Urls.CLIENT_BONUS_ALLOWANCES_LIST} className="u-txt-link">
                  {t('features.Settings.Settings.bonus_rule')}
                </a>
                {t('features.EmployeePays.components.DownloadColumnDetail.can_upload_provision_items_and_deduction_items_set_here')}<br />
                {t('features.EmployeePays.components.DownloadColumnDetail.warning')}<br />
                {t('features.EmployeePays.components.DownloadColumnDetail.leave_automatically_calcuated_provision_and_deduction_items_such_as_insurance_premiums_blank')}<br />
                {t('features.EmployeePays.components.DownloadColumnDetail.items_with_input_value_will_not_be_automatically_calculated')}<br />
                {t('features.EmployeePays.components.DownloadColumnDetail.click_back_to_before_manual_input_button_on_salary_edit_page_to_calculate_automatically_again')}<br />
              </td>
              <td>{t('features.EmployeeBonus.components.DownloadColumnDetail.bonus_amount')}</td>
            </tr>
            <tr>
              <th>{t('features.EmployeePays.components.DownloadColumnDetail.remarks')}</th>
              <td>
                {t('features.EmployeeBonus.components.DownloadColumnDetail.Please_enter_the_information_you_would_like_to_see_in_the_remarks_section_of_the_bonus_statement_255_characters_or_less')}<br />{t('features.EmployeePays.components.DownloadColumnDetail.line_breaks_are_not_reflected')}
              </td>
              <td>{t('features.EmployeeBonus.components.DownloadColumnDetail.A_word_from_the_president_congratulations_on_achieving_the_goals')}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
};

export default DownloadColumnDetail;
